import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
import { QuoteMark } from './graphics/Graphics';
export function Testimonials() {
  const testimonials = [{
    name: 'Margaret T.',
    age: 61,
    location: 'Norwich',
    bundle: 'Buy 2 Get 2 Free',
    quote: 'I actually stayed for the tea and biscuits after book group.',
    body: "For two years I've been making my excuses the second the discussion ended because I was terrified of leaking on my friend's sofa. Last week I stayed for an hour. It sounds so small, but it feels like I've got my life back."
  }, {
    name: 'Christine W.',
    age: 58,
    location: 'Edinburgh',
    bundle: 'Buy 3 Get 3 Free',
    quote: "I wore a silk dress to my daughter's wedding.",
    body: "No dark colours. No thick, rustling pads. No panic when they started the ceilidh dancing. I put a patch on three days before the wedding and didn't think about my bladder once the entire day. The relief is indescribable."
  }, {
    name: 'Patricia H.',
    age: 65,
    location: 'Swansea',
    bundle: 'Starter Pack',
    quote: 'I drove to Cardiff without stopping.',
    body: "Seven years. That's how long I've been mapping out service stations on the M4. Yesterday I drove the whole way to see my sister and didn't even feel the urge until I pulled into her driveway. I sat in the car and cried happy tears."
  }, {
    name: 'Janet K.',
    age: 59,
    location: 'Coventry',
    bundle: 'Buy 2 Get 2 Free',
    quote: 'The day 4 sneeze was my turning point.',
    body: "I was highly sceptical. I've tried every pill and potion going. On day four I had a massive sneezing fit while carrying the laundry basket. I braced myself for the usual disaster... and nothing happened. The muscle just held. Magic."
  }, {
    name: 'Sandra M.',
    age: 62,
    location: 'Dundee',
    bundle: 'Buy 2 Get 2 Free',
    quote: "I've stopped doing the 'modified laugh'.",
    body: "You know the one — where you cross your legs tight and sort of hunch over so you don't leak. I was watching a comedy on TV last night and just belly-laughed normally. My husband actually commented on it. He said it was nice to hear."
  }, {
    name: 'Diane R.',
    age: 57,
    location: 'Bristol',
    bundle: 'Buy 3 Get 3 Free',
    quote: 'Four years of Tena, gone in a fortnight.',
    body: "I thought pads were just my reality now. My GP basically told me to get used to it. I'm furious I wasn't told about the nerve connection sooner, but I'm so grateful I found this. I feel clean and confident again."
  }];
  return <section className="bg-offwhite py-16 md:py-24 px-5" data-id="element-564">
      <div className="max-w-[900px] mx-auto" data-id="element-565">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-566">
          <div className="font-inter text-[12px] uppercase tracking-[0.1em] text-secondary mb-3" data-id="element-567">
            Verified Reviews
          </div>
          <h2 className="font-playfair text-[28px] md:text-[32px] text-ink font-semibold mb-4" data-id="element-568">
            What British Women Are Saying
          </h2>
          <div className="flex items-center justify-center space-x-2" data-id="element-569">
            <div className="flex" data-id="element-570">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-571" />)}
            </div>
            <span className="font-inter text-[14px] text-secondary" data-id="element-572">
              4.8 average from 11,200+ verified purchases
            </span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-573">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 md:p-7 shadow-subtle border-l-[3px] border-gold flex flex-col relative" data-id="element-574">
              <QuoteMark className="absolute top-5 right-5 w-7 h-6 opacity-30" data-id="element-575" />
              <div className="flex mb-4" data-id="element-576">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-577" />)}
              </div>

              <div className="font-inter text-[15px] text-ink leading-[1.7] mb-6 grow" data-id="element-578">
                <span className="font-playfair italic text-[17px] font-medium mr-1" data-id="element-579">
                  "{t.quote}"
                </span>
                {t.body}
              </div>

              <div className="mt-auto border-t border-divider pt-4" data-id="element-580">
                <div className="font-inter font-semibold text-[14px] text-ink mb-2" data-id="element-581">
                  {t.name}, {t.age} — {t.location}
                </div>
                <div className="inline-flex items-center bg-cream rounded-full px-3 py-1 font-inter text-[12px] text-secondary" data-id="element-582">
                  <span className="mr-1.5" data-id="element-583">✅</span> Verified Purchase |{' '}
                  {t.bundle}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}